import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_AboutUs = _resolveComponent("AboutUs")!
  const _component_PopularTopics = _resolveComponent("PopularTopics")!
  const _component_BestOnlineLearningPlatform = _resolveComponent("BestOnlineLearningPlatform")!
  const _component_BuildYourCareer = _resolveComponent("BuildYourCareer")!
  const _component_VideoContent = _resolveComponent("VideoContent")!
  const _component_TeamMembers = _resolveComponent("TeamMembers")!
  const _component_SubscribeNewsletter = _resolveComponent("SubscribeNewsletter")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, { class: "edu-fixed-nav" }),
    _createVNode(_component_PageTitle, {
      pageTitle: "About Us",
      mainTitle: "About Us 2"
    }),
    _createVNode(_component_AboutUs),
    _createVNode(_component_PopularTopics),
    _createVNode(_component_BestOnlineLearningPlatform),
    _createVNode(_component_BuildYourCareer),
    _createVNode(_component_VideoContent),
    _createVNode(_component_TeamMembers),
    _createVNode(_component_SubscribeNewsletter),
    _createVNode(_component_MainFooter)
  ], 64))
}